export default __webpack_public_path__ + "static/media/IMG_6069 copy.13aa7109.jpg";